<template>
  <div class="wrapper">
    <div class="header">
      <span>{{ title }}</span>
    </div>
    <v-chart :option="option" autoresize style="min-height: 500px;width: 100%;" @click="getDataSubset"/>
  </div>
</template>

<script>
import {use} from "echarts/core";
import {CanvasRenderer} from "echarts/renderers";
import {PieChart, LineChart} from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  ToolboxComponent,
  DataZoomComponent
} from "echarts/components";
import VChart from "vue-echarts";

use([
  CanvasRenderer,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  TimelineComponent,
  GridComponent,
  ToolboxComponent,
  LineChart,
  DataZoomComponent
]);
import {mapGetters} from "vuex";
import {TimelineComponent} from 'echarts/components';
import moment from "moment";

const colors = ['#01959E', '#EA6057'];
const labels = ['SE1', 'SE2', 'PreBrSe', 'QA'];
export default {
  name: "ResourceDivision",
  props: {
    division: String,
    title: String
  },
  components: {
    VChart,
  },
  data() {
    return {
      option: {
        barWidth: 40,
        color: colors,
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
          },
          textStyle: {
            fontFamily: 'Helvetica',
            fontSize: 16,
          }
        },
        grid: {
          right: '20%'
        },
        toolbox: {
          feature: {
            saveAsImage: {show: true}
          }
        },
        legend: {
          textStyle: {
            fontFamily: 'Helvetica',
            fontSize: 16,
            fontWeight: 400,
          },
          itemGap: 30
          // data: ['Đang rảnh', 'Đang làm việc'],
        },
        dataZoom: [
          {
            type: 'inside',
            start: 0
          }
        ],
        xAxis: [
          {
            type: 'category',
            axisTick: {
              alignWithLabel: true
            },
            offset: 10,
            // prettier-ignore
            data: labels,
            nameTextStyle: {
              fontWeight: 500,
              fontSize: 16,
              fontFamily: 'Helvetica',
              color: '#303C54'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: 'Số người',
            position: 'left',
            alignTicks: true,
            axisLine: {
              show: true,
              lineStyle: {
                color: colors[0]
              }
            },
            axisLabel: {
              formatter: '{value}'
            },
            nameTextStyle: {
              fontSize: 16,
              fontFamily: 'Helvetica',
            }
          },
        ],
        series: [
          {
            id: 2,
            name: 'Đang làm việc',
            type: 'bar',
            data: [],
            label: {
              show: true,
              align: 'center',
              fontSize: 14,
              fontWeight: 400,
              fontFamily: 'Helvetica',
              color: '#FFFFFF',
              verticalAlign: 'top',
              position: 'insideTop'
            },
          },
          {
            id: 1,
            name: 'Đang rảnh',
            type: 'bar',
            data: [],
            barGap: '0%',
            label: {
              show: true,
              align: 'center',
              fontSize: 14,
              fontWeight: 400,
              fontFamily: 'Helvetica',
              color: '#FFFFFF',
              verticalAlign: 'top',
              position: 'insideTop'
            },
          },
        ]
      }
    };
  },
  async created() {
    await this.getData();
  },
  computed: {
    ...mapGetters({
      resourceDivisionStatistics: "project/resourceDivisionStatistics",
    }),
  },

  methods: {
    async getData() {
      try {
        await this.$store.dispatch("project/getResourceDivisionStatistics", {code: this.$props.division});
        this.resourceDivisionStatistics.forEach((record, index) => {
          if (this.option.series[index].name === record.name) {
            this.option.series[index].data = record.data.map(record => {
              return {
                value: record.number,
                name: record.department_code,
                department_code: this.$props.division
              };
            })
          }
        });
        this.option.legend.textStyle.fontWeight = 400;
      } catch (error) {
        console.log(error)
      }
    },
    getDataSubset(e) {
      let data = {
        activeTab: "tab-list",
        query: {
          status: e.seriesId,
          division: e.data.name,
          footCode: e.data.department_code,
          skill: 0,
          info: '',
          startDate: moment().subtract(7, 'd').format('DD/MM/YYYY'),
          endDate: moment().format('DD/MM/YYYY'),
        }
      };
      this.$emit('clicked-search-records', data);
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  .header {
    width: 100%;
    background: #17A896;
    border-radius: 10px;
    padding: 12px;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 0.0703846px;
    color: #FFFFFF;
  }
}
</style>
